import React from 'react';

import { FormattedMessage } from 'react-intl';

import StyledError from './StyledError';

const Error: React.FC = () => {
  return (
    <StyledError>
      <h1>
        <FormattedMessage id="error.title" />
      </h1>
      <FormattedMessage id="error.general" />
    </StyledError>
  );
};

export default Error;
